import styled from 'styled-components';

export const Container = styled.div`
    display: inline;
`;
export const StyledA = styled.a`
    cursor: pointer;
`;